import { createApp } from 'vue'
import './style.scss'
import App from './App.vue'
import { i18n } from './plugins/i18n'
import { initLocale } from './plugins/locale'
import router from './router'
import { setupAutoLogout } from './auth/autologout'
import { Capacitor } from '@capacitor/core'
import { StatusBar } from '@capacitor/status-bar'
import * as Sentry from '@sentry/capacitor'
import { handleDParam } from './store/domainStore'

initLocale()

async function configureNativeInsets() {
  if (!Capacitor.isNativePlatform()) return
  await StatusBar.setOverlaysWebView({ overlay: false })
  await StatusBar.show()
}

configureNativeInsets()

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_VERSION_NUMBER,
})

const app = createApp(App)

app.config.errorHandler = (err) => {
  Sentry.captureException(err)
}

window.addEventListener('unhandledrejection', (ev) => {
  Sentry.captureException(ev.reason)
})

app.use(router).use(i18n)

setupAutoLogout(router)
handleDParam()

app.mount('#app')
